import React from 'react';
import styled from 'styled-components';

import { List, ListItem, Text } from 'components/chroma';
import { productDisclosureStatementUrl } from 'scenes/common/helpers/contacts';

export const tenantDamage = () => (
  <Text>
    Damage caused by tenants covers you for loss or damage to your building
    and/or contents while at the property and arising from a deliberate or
    intentional act committed by a tenant, except where general exclusions
    apply. Damage caused by tenants excess will apply. For full details please
    read the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const lossOfRent = () => (
  <Text>
    Loss of rent covers you for up to a maximum of 12 months’ rent in the event
    that your property becomes uninhabitable or inaccessible for any reason not
    listed in our general exclusions. Loss of rent excess will apply. For full
    details please read the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const fusionBuilding = () => (
  <Text>
    Motor burnout cover for your Building covers you for the reasonable cost of
    repairing or replacing electric motors that form part of your building (Up
    to $3,000 per claim). Examples of motors covered include electric motors in
    swimming pool pumps, ducted heating or air-conditioning units that are fixed
    to the building. Nominated Building excess applies. For full details please
    read the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const fusionContents = () => (
  <Text>
    Motor burnout cover for your contents covers you for the reasonable cost of
    repairing or replacing electric motors that form part of your contents (Up
    to $2000 per claim). Some examples of motors covered include electric motors
    in freezers, refrigerators, washing machines and dryers. Nominated Contents
    excess applies. For full details please read the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

const ListContainer = styled.div`
  font-size: 1rem;
  p {
    margin-bottom: 0.5rem;
  }
  ul {
    margin-bottom: 1rem;
  }
`;

export const rentDefault = () => (
  <ListContainer>
    <Text>Tenant Rent Default covers you if:</Text>
    <List bullet>
      <ListItem key="tenant-vacates-without-notice">
        your tenant vacates the site without notice before the end date of the
        rental agreement, or
      </ListItem>
      <ListItem key="tenant-defaults">
        your tenant defaults in paying rent owed at the site under the terms of
        the lease, or
      </ListItem>
      <ListItem key="tenant-legally-evicted">
        your tenant is legally evicted for not paying rent or any other breach
        of the rental agreement by the tenant.
      </ListItem>
    </List>

    <Text>
      Maximum payout is up to 10 weeks rent or $5,000 which ever comes first.
      Tenants rent default excess will apply. For full details please read the{' '}
      <a
        href={productDisclosureStatementUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        Product Disclosure Statement
      </a>
      .
    </Text>
  </ListContainer>
);
